import { tv } from "../../variants/tv.js";
const sliderMarkVariants = tv({
    slots: {
        mark: 'bg-neutral-1 absolute top-1/2 h-1 w-1 -translate-x-1/2 -translate-y-1/2 rounded-full',
        label: 'text-neutral-8 absolute left-1/2 top-4 -translate-x-1/2 whitespace-nowrap'
    }
});
export { sliderMarkVariants };
